import { client } from "./api-client";

export const useGetImage = async (path) => {
  const isLocal =
    process.env.REACT_APP_LOCAL_FILE_SYSTEM === "true" ||
    process.env.REACT_APP_LOCAL_FILE_SYSTEM === true;

  if (isLocal) {
    try {
      const response = await client(`common/download/?path=${path}`, {
        config: { responseType: "blob" },
      });
      const blob = new Blob([response.data]);
      const url = URL.createObjectURL(blob);
      return url;
    } catch (e) {
      //empty
      return "";
    }
  }

  return Promise.resolve(path);
};
